var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"companyCard"},[_c('div',{staticClass:"cName"},[_vm._v(_vm._s(_vm.company.name))]),_c('div',{staticClass:"cDescription"},[_vm._v(_vm._s(_vm.company.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }